'use client'

import React from 'react'

import LanguagePickerDropdown from './LanguagePickerDropdown'
import LanguagePickerList from './LanguagePickerList'

export type LanguagePickerProps = {
  align?: 'start' | 'end' | 'center'
  className?: string
  theme?: 'light' | 'dark'
}

const LanguagePicker: React.FC<LanguagePickerProps> = (props) => (
  <LanguagePickerDropdown {...props}>
    <LanguagePickerList />
  </LanguagePickerDropdown>
)

export default LanguagePicker
